/**
 * Global JS
 */
// CSS
import '../scss/global.scss';
import './bootstrap.config.js';
import './ajax_pagination.js';
import './three-recent-posts.js';
import './calendar.js';

const $ = window.jQuery;

let paymentIcons = [
  '<img src="/wp-content/themes/simpler-trading/assets/images/card-visa.svg" alt="visa" class="sv-wc-payment-gateway-icon wc-authorize-net-cim-credit-card-payment-gateway-icon updatedVendorIcon" width="50" height="35" style="width: 50px; height: 35px;"></img>',
  '<img src="/wp-content/themes/simpler-trading/assets/images/card-mastercard.svg" alt="mastercard" class="sv-wc-payment-gateway-icon wc-authorize-net-cim-credit-card-payment-gateway-icon updatedVendorIcon" width="50" height="35" style="width: 50px; height: 35px;"></img>',
  '<img src="/wp-content/themes/simpler-trading/assets/images/card-amex.svg" alt="amex" class="sv-wc-payment-gateway-icon wc-authorize-net-cim-credit-card-payment-gateway-icon updatedVendorIcon" width="50" height="35" style="width: 50px; height: 35px;"></img>',
  '<img src="/wp-content/themes/simpler-trading/assets/images/card-discover.svg" alt="discover" class="sv-wc-payment-gateway-icon wc-authorize-net-cim-credit-card-payment-gateway-icon updatedVendorIcon" width="50" height="35" style="width: 50px; height: 35px;"></img>',
];

// Add the updated vendor payment icons
$(document.body).on('updated_checkout', function () {
  if (!$('.updatedVendorIcon').length) {
    paymentIcons.forEach((e) => {
      $('.sv-wc-payment-gateway-card-icons').append(e);
    });
  }
});

// Components
import './components/videos';
import './components/dotmailer-validation';

$('.simpler--table .button').on('click', () => {
  $('.one_page_checkout').show();
});

// handle mobile view for ST APP

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const isMobileView = Boolean(urlParams.get('mobile_view'));

if (isMobileView) {
  $('#site-navigation').hide();
  $('.site-footer').hide();
  $('.main-navigation').remove();

  $('a:not([href=#])').click(function (e) {
    e.preventDefault();
    const siteUrl = new URL(window.location.href);
    const searchParams = siteUrl.searchParams;
    let fullURl = 'https://' + siteUrl.host + $(this).attr('href');
    if ($(this).attr('href').includes(siteUrl.host)) {
      fullURl = $(this).attr('href');
    } else {
    }
    var url = new URL(fullURl);

    url.searchParams.append('mobile_view', true);

    if (searchParams.get('jwt') != null) {
      url.searchParams.append('jwt', searchParams.get('jwt'));
    }

    var target = $(this).attr('target');
    if (target) {
      window.open(url.toString(), target);
    } else {
      location.assign(url.toString());
    }
  });
}

// Search event to data layer
document.addEventListener('facetwp-loaded', function () {
  window.dataLayer = window.dataLayer || [];
  const facets = FWP.facets;
  const items = getProductList ? getProductList() : [];
  let filterObj = {};
  let facetsCount = 0;
  let course_market = undefined;
  let trader = undefined;

  if (facets) {
    for (const facet in facets) {
      if (Object.hasOwnProperty.call(facets, facet)) {
        const element = facets[facet];

        if (facet === 'store_search' || facet === 'better_search') {
          if (element.length) {
            // update filter object when user uses search
            filterObj.search_term = element;
            filterObj.search_count = facetsCount += 1;
          }
        } else {
          if (element.length) {
            // update filters object when anything but search is used
            filterObj[`${facet}_filter`] = element.join(',');
            filterObj.search_count = facetsCount += element.length;

            if (facet == 'products_traders') {
              trader = filterObj[`${facet}_filter`];
            } else if (facet == 'products_markets') {
              course_market = filterObj[`${facet}_filter`];
            }
          }
        }
      }
    }
  }

  //Check if it is 'search' or 'view' event
  if (!jQuery.isEmptyObject(filterObj)) {
    let eventObj = {
      event: 'search',
    };
    Object.assign(eventObj, filterObj);
    window.dataLayer.push(eventObj);
  }
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_item_list',
    ecommerce: {
      membership_name: undefined,
      course_name: undefined,
      course_market: course_market,
      trader: trader,
      items,
    },
  });
});

$(document).on('click', 'article.product.store-product a', (event) => {
  event.preventDefault();
  try {
    const items = getProductList ? getProductList() : [];
    const { id } = $(event.target).closest('article').data();
    if (items.length > 0) {
      let item = items.filter((product) => {
        return product.item_id == id;
      });

      let product = item[0];
      let traders = product.item_category ? product.item_category : undefined;
      let markets = product.item_category2 ? product.item_category2 : undefined;
      let membership_name =
        product.item_category3 && product.item_category3.includes('Membership')
          ? product.item_name
          : undefined;
      let course_name =
        product.item_category3 && product.item_category3.includes('Courses')
          ? product.item_name
          : undefined;

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'select_item',
        ecommerce: {
          membership_name: membership_name,
          course_name: course_name,
          course_market: markets,
          trader: traders,
          items: item,
        },
      });
    }
  } catch (e) {
    console.log('Error getting product data');
  }
  window.location.href = event.currentTarget.href;
});

document.addEventListener('fire-view-list-gtm', () => {
  const items = getProductList();
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_item_list',
    ecommerce: {
      membership_name: undefined,
      course_name: undefined,
      course_market: undefined,
      trader: undefined,
      items,
    },
  });
});

window.formattingDatalayer = function (items) {
  if (Array.isArray(items)) {
    items.map((item) => {
      Object.keys(item).forEach((key) => {
        if (!item[key]) {
          item[key] = undefined;
        }
      });
    });
  } else if (typeof items === 'object') {
    Object.keys(items).forEach((key) => {
      if (Array.isArray(items[key])) {
        items[key] = formattingDatalayer(items[key]);
      } else {
        if (!items[key]) {
          items[key] = undefined;
        }
      }
    });
  }
  return items;
};

$(function () {
  $('form.cart').one('submit', (e) => {
    try {
      let prodId = $(e.target).children('button[type="submit"]')[0].value;
      $.ajax({
        type: 'POST',
        url: '/wp-json/datalayer/product',
        async: false,
        data: {
          datalayer: true,
          products: JSON.stringify([prodId]),
        },
      }).done(function (data) {
        if (data && !data.includes('DOCTYPE')) {
          let items = JSON.parse(data);
          items = formattingDatalayer(items);

          let product = items[0];
          let traders = product.item_category
            ? product.item_category
            : undefined;
          let markets = product.item_category2
            ? product.item_category2
            : undefined;
          let course_name =
            product.item_category3 && product.item_category3.includes('Courses')
              ? product.item_name
              : undefined;
          let membership_name =
            product.item_category3 &&
            product.item_category3.includes('Membership')
              ? product.item_name
              : undefined;

          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              membership_name: membership_name,
              course_name: course_name,
              course_market: markets,
              trader: traders,
              upsell: undefined,
              items,
            },
          });
        }
      });
    } catch (e) {
      console.log('Error getting product data');
    }
  });

  //Check if page has buy now links
  let buyNowLinks = $('a[href*="buy-now"]');
  if (buyNowLinks.length > 0) {
    var presentProducts = [];
    buyNowLinks.each((index, target) => {
      let link = target.href;
      const searchParams = new URLSearchParams(
        link.substring(link.indexOf('?'))
      );
      presentProducts.push(searchParams.get('buy-now'));

      $(target).click((e) => {
        e.preventDefault();
        let link = e.currentTarget.href;
        try {
          const searchParams = new URLSearchParams(
            link.substring(link.indexOf('?'))
          );
          const id = searchParams.get('buy-now');
          $.ajax({
            type: 'POST',
            url: '/wp-json/datalayer/product',
            data: {
              datalayer: true,
              products: JSON.stringify([id]),
            },
          })
            .done(function (data) {
              if (data && data.length > 0 && !data.includes('DOCTYPE')) {
                let items = JSON.parse(data);
                if (items.length <= 0) return;

                items = formattingDatalayer(items);
                let product = items[0];
                let traders = product.item_category
                  ? product.item_category
                  : undefined;
                let markets = product.item_category2
                  ? product.item_category2
                  : undefined;
                let course_name =
                  product.item_category3 &&
                  product.item_category3.includes('Courses')
                    ? product.item_name
                    : undefined;
                let membership_name =
                  product.item_category3 &&
                  product.item_category3.includes('Membership')
                    ? product.item_name
                    : undefined;

                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                  event: 'add_to_cart',
                  ecommerce: {
                    membership_name: membership_name,
                    course_name: course_name,
                    course_market: markets,
                    trader: traders,
                    upsell: undefined,
                    items,
                  },
                });
              }
              window.location.href = e.currentTarget.href;
            })
            .fail(function (error) {
              window.location.href = e.currentTarget.href;
            });
        } catch (e) {
          window.location.href = e.currentTarget.href;
        }
      });
    });

    presentProducts = presentProducts.filter(
      (item, index) => presentProducts.indexOf(item) === index
    );

    $.ajax({
      type: 'POST',
      url: '/wp-json/datalayer/product',
      data: {
        datalayer: true,
        products: JSON.stringify(presentProducts),
      },
    }).done(function (data) {
      if (data && !data.includes('DOCTYPE')) {
        let items = JSON.parse(data);
        if (items.length <= 0) return;

        items = formattingDatalayer(items);

        let product = items[0];
        let traders = product.item_category ? product.item_category : undefined;
        let markets = product.item_category2
          ? product.item_category2
          : undefined;
        let membership_name =
          product.item_category3 &&
          product.item_category3.includes('Membership')
            ? product.item_name
            : undefined;
        let course_name =
          product.item_category3 && product.item_category3.includes('Courses')
            ? product.item_name
            : undefined;

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'view_item',
          ecommerce: {
            membership_name: membership_name,
            course_name: course_name,
            course_market: markets,
            trader: traders,
            items,
          },
        });
      }
    });
  }
});
